import { useQuery } from '@tanstack/react-query';
import { fetchRecommendations, type RecommendationsResponse } from '@/services/recommendationService';

/**
 * The student "Recommended for you" rail. Auth-gated — only fires when a token
 * is present. One call, server-ranked; the component renders items as-is.
 */
export function useRecommendations(accessToken: string | undefined, size?: number) {
  return useQuery<RecommendationsResponse>({
    queryKey: ['recommendations', { size }],
    queryFn: () => fetchRecommendations(accessToken as string, { size }),
    enabled: !!accessToken,
    staleTime: 5 * 60 * 1000,
  });
}
